import { Injectable, Inject } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';
import { CommonUtilty } from '../utilities/commonUtility'
import { AppMetadataHandler } from '../../configs/app-metadata.handler'
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable()
export class IntimationService {

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService,
        private commonUtilty: CommonUtilty,
        public appMetadataHandler: AppMetadataHandler,
        public msgService: NzMessageService
    ) { }

    fetchAPIMetaData(apiName: any): Observable<any> {
        let me = this;

        let APIMetaDataDataSubject = new Subject<any>();
        
        let pathVariables = [];
        pathVariables.push(apiName);
        this.apiRequest.getCallWithAPIMapper('fetchByAPIName', null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                APIMetaDataDataSubject.next(returnObj);
            });

        return APIMetaDataDataSubject;
    }


    saveIntimation(body: any): Observable<any> {
        let me = this;

        let IntimationSubject = new Subject<any>();

        this.apiRequest.post('claim/Intimation/save', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                IntimationSubject.next(returnObj);
            });

        return IntimationSubject;
    }

    getIntimationByGuid(guid: any) {
        let me = this;
        let url
        let IntimationDataSubject = new Subject<any>();
        if (this.appMetadataHandler.featureFlags.changeURLOfClaimIntimation) {
            url = 'claim/Intimation/fetchByGuid/'
        }
        else {
            url = 'claim/Intimation/fetchByGuid/'
        }

        this.apiRequest.get(url + guid)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                IntimationDataSubject.next(returnObj);
            });

        return IntimationDataSubject;
    }

    submitIntimation(body: any): Observable<any> {
        let me = this;

        let IntimationSubject = new Subject<any>();

        this.apiRequest.post('claim/Intimation/submit', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                IntimationSubject.next(returnObj);
            });

        return IntimationSubject;
    }


    convertIntimationToClaim(guid: any) {
        let me = this;

        let IntimationDataSubject = new Subject<any>();

        this.apiRequest.get('claim/Intimation/convert/' + guid)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                IntimationDataSubject.next(returnObj);
            });

        return IntimationDataSubject;
    }

    getIntimationMetadataByGuid(guid: any) {
        let me = this;
        let url='intMetadata/findByEntityGuid/'
        let IntimationDataSubject = new Subject<any>();
        this.apiRequest.get(url + guid)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                IntimationDataSubject.next(returnObj);
            });

        return IntimationDataSubject;
    }


    processBulkIntimation(body: any): Observable<any> {
        let me = this;

        let IntimationSubject = new Subject<any>();
        this.apiRequest.post('intMetadata/process', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                IntimationSubject.next(returnObj);
            });

        return IntimationSubject;
    }
    getMetaData(reportName: any): Observable<any> {
        let me = this;

        let APIMetaDataDataSubject = new Subject<any>();

        this.apiRequest.get('report/fetchMetaData/' + reportName)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                APIMetaDataDataSubject.next(returnObj);
            });

        return APIMetaDataDataSubject;
    }
    generateExcel(body: any): Observable<any> {
        let me = this;

        let reportSubject = new Subject<any>();
        this.apiRequest.postCallWithAPIMapper('generateReport', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                reportSubject.next(returnObj);
            });

        return reportSubject;
    }
    generateReport(body: any): Observable<any> {
        let me = this;

        let reportSubject = new Subject<any>();
        this.apiRequest.postCallWithAPIMapper('fetchReport', body)
            .subscribe(jsonResp => {
                if (jsonResp) {
                    let returnObj = this.commonUtilty.deepCopy(jsonResp);
                    console.log(returnObj);
                    reportSubject.next(returnObj);
                } else {
                    this.msgService.error('Server Error - Technical issue occurred, please contact IT Support.', { nzDuration: 4000 })
                }
            });

        return reportSubject;
    }

    getIntimationDataByGuid(guid: any) {
        let me = this;

        let IntimationDataSubject = new Subject<any>();

        this.apiRequest.getCallWithAPIMapper('claimIntimationFetchByGuid/' + guid)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                IntimationDataSubject.next(returnObj);
            });

        return IntimationDataSubject;
    }

    fetchByIntimationNumber(intimationNum) {
        let fetchedIntimationSubject = new Subject<any>();
        //let url = "omniintake-service/claim/Intimation/fetchByIntimationNum/";
        let url = "interface/external/fetchByIntimationNum/";

        this.apiRequest.get(url + intimationNum, null, null, true)
            .subscribe(response => {
                let returnObj = response;
                fetchedIntimationSubject.next(returnObj);
            });

        return fetchedIntimationSubject;
    }



}


